import device from './device';

const handler = () => {
  const wrapper = document.querySelector('.c-service');
  const items = wrapper.querySelectorAll('.c-service__post');
  let actives = 0;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < items.length; i++) {
    const content = items[i].querySelector('.c-service__post__content');
    if (content.classList.contains('c-service__post__content--active')) {
      actives += 1;
    }
  }

  if (actives < 1) {
    wrapper.classList.remove('c-service--active');
  } else {
    wrapper.classList.add('c-service--active');
  }
};

const close = (index = -1, excluded = -1) => {
  const list = document.querySelector('.c-service');
  const listItems = list.querySelectorAll('.c-service__post');

  if (index !== -1) {
    const content = listItems[index].querySelector('.c-service__post__content');
    content.classList.remove('c-service__post__content--active');
  } else {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < listItems.length; i++) {
      if (excluded !== i) {
        const content = listItems[i].querySelector('.c-service__post__content');
        content.classList.remove('c-service__post__content--active');
      }
    }
    if (excluded !== -1) {
      list.classList.remove('c-service--active');
    }
  }
  if (index === -1 && excluded === -1) {
    list.classList.remove('c-service--active');
  }
};

const hover = (index = -1, type) => {
  const list = document.querySelector('.c-service');
  const listItems = list.querySelectorAll('.c-service__post');
  const content = listItems[index].querySelector('.c-service__post__content');

  if (type === 'enter') {
    list.classList.add('c-service--hover');
    content.classList.add('c-service__post__content--hover');
  } else if (type === 'exit') {
    list.classList.remove('c-service--hover');
    content.classList.remove('c-service__post__content--hover');
  }
};

const click = (index = -1) => {
  const list = document.querySelector('.c-service');
  const listItems = list.querySelectorAll('.c-service__post');
  const content = listItems[index].querySelector('.c-service__post__content');
  const active = !!content.classList.contains(
    'c-service__post__content--active',
  );

  if (!active) {
    content.classList.add('c-service__post__content--active');
    close(-1, index);
  } else {
    content.classList.remove('c-service__post__content--active');
  }

  handler();
};

const list = () => {
  const listElem = document.querySelector('.c-service');

  if (listElem) {
    // # body click close event
    document.addEventListener('click', event => {
      if (event.target.closest('.c-service__post')) return;
      close();
    });

    const listItems = listElem.querySelectorAll('.c-service__post');

    if (listItems.length) {
      if (!device.touch() || device.desktop()) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < listItems.length; i++) {
          listItems[i].addEventListener('mouseenter', () => {
            hover(i, 'enter');
          });
          listItems[i].addEventListener('mouseleave', () => {
            hover(i, 'exit');
          });
          listItems[i].addEventListener('click', () => {
            click(i);
          });
        }
      } else {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < listItems.length; i++) {
          const title = listItems[i].querySelector('.c-service__post__name');

          title.onclick = () => {
            listItems[i].classList.toggle('c-service__post--active');
          };
        }
      }
    }
  }
};

export default { list };



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/service.js